module.exports = __webpack_public_path__ + "img/symbol_4.76a7861f.png";